export const LEVEL_TONE_GOOD = 'good';
export const LEVEL_TONE_WARNING = 'warning';
export const LEVEL_TONE_BAD = 'bad';

const TONES_BY_LEVEL = {
  A: LEVEL_TONE_GOOD,
  B: LEVEL_TONE_WARNING,
  C: LEVEL_TONE_BAD
};

export const getOnDemandLevelTone = level => TONES_BY_LEVEL[level] || null;
